<template>
  <div>
    <section>
      <div class="col-md-12 no-padding">
        <section-title :title="$t('message.customer')"/>
        <div class="form-row mb-2">
          <div class="col-12">
            <label>{{ $t('message.storecompanyperson') }}</label>
            <select
              :disabled="true"
              class="form-control form-control-sm custom-select">
              <option v-if="inv.customer">{{ inv.customer.customer_name }}</option>
            </select>
          </div>
        </div>
        <div class="form-row mb-2">
          <div class="col-6">
            <div class="form-group row mb-1">
              <div class="col-md-12">
                <label>{{ $t('message.address') }}</label>
                <textarea
                  :disabled="true"
                  class="form-control"
                  style="height: 150px;">{{ inv.customer.address }}</textarea>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row mb-1">
              <div class="col-md-12">
                <label>{{ $t('message.tel') }}</label>
                <input
                  :disabled="true"
                  :value="getPartnerContact(inv.customer.contacts).tel"
                  type="text"
                  class="form-control">
              </div>
            </div>
            <div class="form-group row mb-1">
              <div class="col-md-12">
                <label>{{ $t('message.email') }}</label>
                <input
                  :disabled="true"
                  :value="getPartnerContact(inv.customer.contacts).email"
                  type="text"
                  class="form-control">
              </div>
            </div>
            <div class="form-group row mb-0">
              <div class="col-md-12">
                <label>{{ $t('message.taxpayerno') }}</label>
                <input
                  :disabled="true"
                  :value="inv.customer.tax_id"
                  type="text"
                  class="form-control">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="col-md-12 no-padding">
        <section-title :title="$t('message.reference')"/>
        <div class="form-row">
          <div class="col-md-12">
            <label>{{ $t('documents.so') }}</label>
            <select
              :disabled="true"
              class="form-control form-control-sm custom-select">
              <option>{{ inv.in_code }}</option>
            </select>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="col-md-12 no-padding">
        <section-header :title="$t('message.date')"/>
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group row">
              <div class="col">
                <label>{{ $t('message.date') }}</label>
                <BaseInputDatePicker
                  v-model="form.created_at"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="col-md-12 no-padding">
        <section-header :title="$t('message.infopayment')"/>
        <div class="form-row">
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col">
                <label>{{ $t('message.paidat') }}</label>
                <BaseInputDatePicker
                  v-model="form.paid_at"
                  mode="dateTime"
                  is24hr
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col">
                <label>{{ $t('message.paymentmethod') }}</label>
                <select
                  v-model="form.payment_method"
                  class="form-control form-control-sm custom-select"
                >
                  <option :value="null">{{ $t('placeholder.select') }}</option>
                  <option value="cash">{{ $t('payment_methods.cash') }}</option>
                  <option value="card">{{ $t('payment_methods.card') }}</option>
                  <option value="promptpay">{{ $t('payment_methods.promptpay') }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col">
                <label>{{ $t('message.paidamount', {string:currency}) }}</label>
                <input
                  v-model="form.paid_amount"
                  type="text"
                  class="form-control number-only text-select-all"
                  @keypress="numberOnly"
                  @keyup="form.paid_amount = setToValidNumber(form.paid_amount)"
                  @blur="form.paid_amount = setToCustomDigitsNumber(form.paid_amount)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="no-margin">
      <div class="col-md-12 no-padding">
        <section-title :title="$t('message.orderlist')"/>
        <order
          :data="form.orders"
          :disabled="false"
          :validation="trickValidation"
          type="rt"/>
      </div>
    </section>
    <section class="no-margin">
      <div class="col-md-12 no-padding">
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group row">
              <div class="col-md-12">
                <textarea
                  :placeholder="$t('placeholder.note')"
                  v-model="form.note"
                  class="form-control"
                  style="min-height: 126px;"/>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="col-md-12 row no-padding no-margin">

              <div class="col-12 row no-margin no-padding">
                <div class="col-6 no-padding mb-2">
                  {{ $t('message.total') }}
                </div>
                <div class="col-6 no-padding mb-2 text-right">
                  {{ getNumber(getTotal(form.orders).sub) }}
                </div>
              </div>

              <div
                v-if="getTotal(form.orders).discount > 0"
                class="col-12 row no-margin no-padding">
                <div class="col-6 no-padding mb-2">
                  {{ $t('message.discount') }}
                </div>
                <div class="col-6 no-padding mb-2 text-right">
                  {{ getNumber(getTotal(form.orders).discount) }}
                </div>
              </div>

              <div
                v-if="getTotal(form.orders).discount > 0"
                class="col-12 row no-margin no-padding">
                <div class="col-6 no-padding mb-2">
                  {{ $t('message.discounted_total') }}
                </div>
                <div class="col-6 no-padding mb-2 text-right">
                  {{ getNumber(getTotal(form.orders).sub - getTotal(form.orders).discount) }}
                </div>
              </div>

              <div
                v-for="(tax, index) in taxResults"
                :key="index"
                class="col-12 row no-margin no-padding"
              >
                <div class="col-6 no-padding mb-2">
                  {{ tax.displayText }}
                </div>
                <div class="col-6 no-padding mb-2 text-right">
                  {{ getNumber(tax.total) }}
                </div>
              </div>

              <div class="col-12 row no-margin no-padding">
                <div class="col-6 no-padding">
                  {{ $t('message.grandtotal') }}
                </div>
                <div class="col-6 no-padding text-right">
                  <span :class="[{'text-underline-border': !isActiveWht}]">
                    {{ getNumber(getTotal(form.orders).grand) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TAX_FORM_TYPE } from '@/helpers/enum'
import _, { cloneDeep } from 'lodash'

export default {
  props: {
    inv: {
      type: Object,
    },
    validation: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      form: {
        note: '',
        approved: true,
        orders: [],
        created_at: null,
        scheduled_at: null,
        selectedCredit: '',
        inputCustomCreditDay: 0,
        paid_amount: 0,
        paid_at: new Date(),
        payment_method: 'cash',
      },
      trickValidation: 0,
      isFocusOnInputScheduled: false,
    }
  },
  computed: {
    ...mapGetters({
      currency: 'getCurrency',
      getPartnerContact: 'getPartnerContact',
      vat: 'getVat',
    }),
    whtRate () {
      var whtPercent = undefined
      for (let i in this.form.orders) {
        let order = this.form.orders[i]
        for (let j in order.taxes) {
          let tax = order.taxes[j]
          if (tax.name == '{wht}') {
            whtPercent = tax.amount
          }
        }
      }
      return whtPercent
    },
    isActiveWht () {
      return this.getTotal(this.form.orders).taxes.wht != 0
    },
    taxResults () {
      const isGroupTaxName = false
      const oders = this.getDataSetOrders(this.form.orders)
      return this.getTaxesByOrders(oders, isGroupTaxName).map((tax) => {
        return {
          form_type: tax.form_type,
          taxRate: tax.amount,
          total: (() => {
            if (tax.amount <= -1) {
              return Math.abs(tax.total)
            }
            return tax.total
          })(),
          displayText: tax.displayText,
        }
      })
    },
  },
  methods: {
    ...mapActions([

    ]),
    validateform () {
      var isValid = false
      var data = null
      this.trickValidation++
      const orders = this.form.orders.filter((order) => order.sku_id)
      if (orders.length) {
        isValid = true
        data = {
          created_at: this.form.created_at,
          scheduled_at: this.form.scheduled_at,
          selectedCredit: this.form.selectedCredit,
          inputCustomCreditDay: this.form.inputCustomCreditDay,
          orders: orders,
          note: this.form.note.trim() ? this.form.note.trim() : null,
          approved: this.form.approved,
          paid_amount: this.form.paid_amount,
          paid_at: this.form.paid_at,
          payment_method: this.form.payment_method,
        }
      }
      this.$emit('submit', isValid, data)
    },
    keyupInputCustomCreditDay (e) {
      var value = this.form.inputCustomCreditDay.toString()
      if (value) {
        if (value.search('0') == 0) {
          value = value.substring(1, value.length)
          this.form.inputCustomCreditDay = value
        }
      }
    },
    getDataSetOrders (orders) {
      const data = _.cloneDeep(orders)
      const newData = []
      // remove key, data we don't need
      for (const i in data) {
        const item = data[i]
        if (item.sku_id) {
          newData.push({
            item: item.item,
            description: item.description,
            sku_id: item.sku_id,
            quantity: parseFloat(item.quantity) || 0,
            price: parseFloat(item.price) || 0,
            discounts: item.discounts.map((discount) => ({
              ...discount,
              type: 'general',
              value_amount: parseFloat(discount.value_amount),
            })),
            taxes: item.taxes.map((tax) => ({
              name: tax.tax_name,
              type: tax.type,
              amount: tax.amount,
              form_type: tax.form_type,
              group_name: tax.group_name,
              is_display_fee_result: tax.is_display_fee_result,
              is_for_sale: tax.is_for_sale,
              is_for_purchase: tax.is_for_purchase,
              fee: tax.fee ? tax.fee : null,
              tax_id: tax.tax_id,
            })),
          })
        }
      }
      return newData
    },
  },
  watch: {
    validation () {
      this.validateform()
    },
    'form.selectedCredit': {
      handler: function (after, before) {
        if (!before) {
          return
        }
        let value = after
        if (value.search('days.') >= 0) {
          let arr = value.split('.')
          let days = parseInt(arr[1])
          this.form.scheduled_at = this.moment(this.form.created_at).add(days, 'day').toDate()
        } else if (value == 'custom') {
          let that = this
          if (!this.isFocusOnInputScheduled) {
            if (before.search('days.') >= 0) {
              let arr = before.split('.')
              let days = parseInt(arr[1])
              this.form.inputCustomCreditDay = days
            } else {
              this.form.scheduled_at = this.moment(this.form.created_at).toDate()
              this.form.inputCustomCreditDay = 0
            }
          }
          setTimeout(() => {
            that.$refs.custom_credit_days.focus()
          }, 100)
        } else if (value == 'cash') {
          this.form.scheduled_at = this.moment(this.form.created_at).toDate()
        }
      },
      deep: true,
    },
    'form.created_at': {
      handler: function (after) {
        var days = null

        if (this.form.selectedCredit == 'custom') {
          days = parseInt(this.form.inputCustomCreditDay)
        } else if (this.form.selectedCredit.search('days.') >= 0) {
          let arr = this.form.selectedCredit.split('.')
          days = parseInt(arr[1])
        }

        if (days !== null) {
          this.form.scheduled_at = this.moment(this.form.created_at).add(days, 'day').toDate()
        }
      },
      deep: true,
    },
    'form.scheduled_at': {
      handler: function (after, before) {
        if (this.isFocusOnInputScheduled) {
          if (this.form.selectedCredit.search('days.') >= 0 || this.form.selectedCredit == 'custom') {
            var a = this.moment(this.form.scheduled_at)
            var b = this.moment(this.form.created_at)
            var diff = Math.round(a.diff(b, 'days', true)) // diff days
            this.form.inputCustomCreditDay = diff
            this.form.selectedCredit = 'custom'
          }
        }
      },
      deep: true,
    },
    'form.inputCustomCreditDay': {
      handler: function (after) {
        var value = after.toString()
        let days = parseInt(value)
        if (days >= 0) {
          this.form.scheduled_at = this.moment(this.form.created_at).add(days, 'day').toDate()
        } else {
          this.form.inputCustomCreditDay = 0
        }
      },
      deep: true,
    },
    'form.orders': {
      handler: function () {
        this.form.paid_amount = this.setToCustomDigitsNumber(this.getTotal(this.form.orders).grand)
      },
      deep: true,
    },
  },
  created: async function () {
    if (this.inv.credit.type == 'days') {
      var arr = [15, 30, 60, 90]
      if (arr.indexOf(this.inv.credit.days) >= 0) {
        this.form.selectedCredit = 'days.' + this.inv.credit.days.toString()
      } else {
        this.form.selectedCredit = 'custom'
        this.form.inputCustomCreditDay = this.inv.credit.days.toString()
      }
    } else {
      this.form.selectedCredit = this.inv.credit.type
    }
    this.form.created_at = new Date()
    if (this.inv.scheduled_at) {
      this.form.scheduled_at = new Date(this.inv.scheduled_at)
    }

    // set default data for Order.vue
    this.form.orders = cloneDeep(this.getDefaultDataForOrderVue(this.inv.orders))

    this.form.paid_amount = this.setToCustomDigitsNumber(this.getTotal(this.form.orders).grand)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/custom/FormReceipt.vue